// removed by extract-text-webpack-plugin
module.exports = {"list":"DeveloperAppsList__list___2_gVQ","element":"DeveloperAppsList__element___3ZH2Y"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/packages/components/Layout/DeveloperAppsList.scss
// module id = 544
// module chunks = 0